// customization:
// - replaced map with object list widget to add unlimited location filters

import React, { useEffect } from 'react';
import { CheckboxWidget, ObjectListWidget } from '@plone/volto/components';
import { defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
  show_location_filters: {
    id: 'Mostra i filtri per luogo',
    defaultMessage: 'Mostra i filtri per luogo',
  },
  location_filter_label: {
    id: 'Etichetta location filter',
    defaultMessage: 'Etichetta',
  },
  location_filter_location: {
    id: 'Luogo location filter',
    defaultMessage: 'Luogo',
  },
  location_filter_add: {
    id: 'Aggiungi filtro',
    defaultMessage: 'Aggiungi filtro',
  },
  location_filter_item: {
    id: 'location_filter_item',
    defaultMessage: 'Filtro per luogo',
  },
});

const schema = (intl) => ({
  title: intl.formatMessage(messages.location_filter_item),
  addMessage: intl.formatMessage(messages.location_filter_add),
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['label', 'location'],
    },
  ],
  properties: {
    label: {
      title: intl.formatMessage(messages.location_filter_label),
    },
    location: {
      title: intl.formatMessage(messages.location_filter_location),
      widget: 'object_browser',
      mode: 'link',
      widgetOptions: { pattern_options: { selectableTypes: ['Venue'] } },
    },
  },
  required: [],
});

const LocationFiltersWidget = (props) => {
  const intl = useIntl();
  const { id, title, value, onChange, formData } = props;

  useEffect(() => {
    if (!formData.location_filters) {
      onChange('location_filters', []);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <CheckboxWidget id={id} title={title} value={value} onChange={onChange} />
      {value && (
        <ObjectListWidget
          id="location_filters"
          schema={schema(intl)}
          value={formData.location_filters || []}
          onChange={onChange}
        />
      )}
    </>
  );
};

export default LocationFiltersWidget;
